<template>
    <div class="relative flex items-start flex-col h-full" data-active-step="active">
        <div class="flex flex-row gap-0 -mb-0.5">
            <span class="px-2 paragraph-2xs text-secondary collection:text-secondary-inverse color-cta">{{ label }}</span>
        </div>

        <div class="flex flex-row gap-0 h-7">
            <component
                :is="muted ? 'span' : 'router-link'"
                :to="muted ? undefined : to"
                :title="name"
                :class="[
                    'group relative inline-flex pl-2 pr-1 items-center rounded-1 paragraph-sm-bold',
                    muted
                        ? 'text-disabled cursor-default'
                        : 'text-primary collection:text-primary-inverse'
                ]"
            >
                <span class="max-w-52 truncate">{{ name }}</span>
                <div v-if="active && !muted" class="pointer-events-none absolute -bottom-[11px] left-0 w-full h-[4px] bg-nav-accent" />
                <div v-else-if="!muted" class="pointer-events-none absolute -bottom-[11px] left-0 w-full h-[4px] bg-nav-accent opacity-0 group-hover:opacity-40 transition-opacity duration-75" />
            </component>

            <button
                v-if="switchable && !muted"
                class="inline-flex items-center justify-center p-1 rounded-1 hover:bg-primary-ghost collection:hover:bg-primary-ghost-inverse transition-colors cursor-pointer duration-75"
                @click="handleToggleDropdown"
            >
                <Icon name="chevron-down" :size="20" class="text-primary collection:text-primary-inverse" />
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import Icon from '@/vue/components/design-system/icon/Icon.vue'

type Props = {
    label: string
    name: string
    to: RouteLocationRaw
    active?: boolean
    switchable?: boolean
    muted?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    active: false,
    switchable: true,
    muted: false,
})

const emit = defineEmits<{
    'toggle-dropdown': []
}>()

function handleToggleDropdown() {
    emit('toggle-dropdown')
}

</script>
